import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { OperationDto } from './operations.dto';

export class AllOperationsResponseModel extends GlobalResponseObject{
    data?: OperationDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: OperationDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}
